import Vue from "vue";

const getDefaultState = () => {
    return {
        products: [],
        selectedProduct: {
            name: "",
            price: 0
        },
        productsPrice: [],
    };
};

const Products = {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        SET_PRODUCTS: async (state, payload) => {
            state.products = payload;
        },

        RESET_STATE: state => {
            Object.assign(state, getDefaultState());
        },


        SET_SELECTED_PRODUCT: (state, payload) => {
            state.selectedProduct = payload;
        },

        SET_PRODUCTS_PRICE: (state, payload) => {
            state.productsPrice = payload;
        }
    },
    actions: {
        fetch: ({commit}) => {
            return Vue.prototype.$apiService.get("products").then(response => {
                commit("SET_PRODUCTS", response.data);
            }).catch(err => console.log(err.response));
        },

        resetState: ({commit}) => {
            commit("RESET_STATE");
        },

        fetchLuts: ({ rootState }, product_id) => {
            return Vue.prototype.$apiService.get(`accounts/${rootState.User.account.id}/products/${product_id}/luts`)
                .then(({data}) => {
                    return data;
                })
        },

        fetchAllPrices: ({commit}) => {
            return Vue.prototype.$apiService.get(`products/price`)
                .then(({data}) => {
                    commit("SET_PRODUCTS_PRICE", data);
                    return data;
                })
        }
    },
    getters: {
        getProductPrice: (state, getters, rootState) => slug => {
            if (slug.includes(rootState.Plans.PLAN_LITE.slug)) {
                slug = slug.split('-no-trial')[0];
            }

            const product = state.productsPrice.find(product => product.product == slug);
            if (!product) return 0

            return product.pricing.US.price;
        },

        getProductDiscount: (state, getters, rootState) => slug => {
            if (slug.includes(rootState.Plans.PLAN_LITE.slug)) {
                slug = slug.split('-no-trial')[0];
            }

            const product = state.productsPrice.find(product => product.product == slug);
            if (!product || product.pricing.US.quantityDiscount.length == 0) return 0;

            return product.pricing.US.quantityDiscount[1].discountValue;
        },
    },
};

export default Products;
